/* eslint-disable camelcase */
import { useEffect } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import type { CnstrcPurchaseDataItem } from '@/modules/perseo-billing/interfaces';
import type { IOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  isDeviceAndroid,
  isDeviceIos
} from '@/modules/shared/utils/deviceDetections';

const { VITE_CONSTRUCTOR_PURCHASE_WEBVIEW_ENABLED } = import.meta.env;

const IS_CONSTRUCTOR_WEBVIEW_ENABLED =
  VITE_CONSTRUCTOR_PURCHASE_WEBVIEW_ENABLED === 'true';

const CLPToNumber = (clp: string) => Number(clp.replace(/[$,.]/g, ''));

const isWebView = isDeviceAndroid() || isDeviceIos();
const shouldSkipConstructor = !IS_CONSTRUCTOR_WEBVIEW_ENABLED && isWebView;

const useConstructorPurchaseConfirmation = () => {
  const billing = useAppSelector((state) => state.billing);
  const paymentSuccess = billing.paymentSuccess as IOrderConfirmation;
  const basketSummary = paymentSuccess?.basketSummary;

  useEffect(() => {
    if (shouldSkipConstructor) return;

    const items: CnstrcPurchaseDataItem[] = [];
    let revenue: number = 0;

    basketSummary?.map((basket) =>
      basket?.items?.map((item) => {
        const price = item?.price?.price ?? 0;
        const quantity = item?.quantity ?? 0;
        items.push({
          item_id: item?.productKey ?? '',
          variation_id: item?.sku ?? '',
          count: item?.quantity ?? 0,
          price: CLPToNumber(price)
        });
        revenue += CLPToNumber(price) * quantity;
      })
    );

    window.cnstrcPurchaseData = {
      items: items,
      order_id: paymentSuccess?.order ?? '',
      revenue: revenue ?? 0
    };
  }, [basketSummary, paymentSuccess]);
};

export default useConstructorPurchaseConfirmation;
